import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { El } from '~/components/Layout/style';
import { StyledFiltersOptions } from '../style'
import { Checkbox, Dropdown } from 'semantic-ui-react';
import ExcelExport from '~/components/ExcelExport';
import { useNavigate } from 'react-router-dom';
import { RouteTypes } from '~/routes/constants';
import cloneDeep from 'lodash.clonedeep'
import { ThemeContext } from 'styled-components';
import { useAuth } from '~/routes/components/AuthProvider';
import { ADMIN_ROLE_SLUG, OPERATIVE_ROLE_SLUG } from '~/Constants';
import { SwissFarmerContext, getSwissFarmersFilters } from '../SwissFarmerProviderComp';
import { FarmersOptionsType } from '~/api/services/farmers/index';

interface ActionsProps {
  dataFiltered: any
  lightUserLogged: boolean
  handleImportClick: () => void
  defaultFilterValues: any
  handleChangeDataFiltered: (data: any) => void
  farmersListOptions: FarmersOptionsType
}

const Actions: React.FC<ActionsProps> = (props) => {
  const { firstColor } = useContext(ThemeContext)
  const { systemData: { logged: { roleSlug }, operativeUsersCanSeeFarmersInfo } } = useAuth()
  const { t } = useTranslation()
  const {
    contextValues,
    contextValues: {
      checkedFilters
    },
    setContextValues
  } = useContext(SwissFarmerContext)
  const navigate = useNavigate()
  const {
    lightUserLogged,
    handleImportClick,
    defaultFilterValues,
    dataFiltered,
    handleChangeDataFiltered,
    farmersListOptions
  } = props

  const filterValues = []
  const [filters, setFilters] = useState(filterValues)
  const [checkedFarmerExportTypes, setCheckedFarmerExportTypes] = useState([])

  useEffect(() => {
    setCheckedFarmerExportTypes(farmersListOptions?.types?.filter(type => type.key !== 'all_farmers') || [])
    setFilters(filterValues)
  }, [t]);

  const showExportFarmer = (roleSlug === ADMIN_ROLE_SLUG) || ((roleSlug === OPERATIVE_ROLE_SLUG) && operativeUsersCanSeeFarmersInfo)
  const showImportFarmers = Boolean(farmersListOptions?.farmersImport) && showExportFarmer
  const payload = cloneDeep(dataFiltered)
  delete payload.rows
  delete payload.page
  const payloadFarmersExport = {
    types: checkedFarmerExportTypes?.map(type => type?.key),
    ...payload
  }

  function handleCheckFilters(checked, filter) {
    if (checked) {
      setContextValues({
        ...contextValues,
        checkedFilters: [...contextValues.checkedFilters, filter]
      })
      localStorage.setItem('swissFarmersFilters', JSON.stringify([...contextValues.checkedFilters, filter]))
    } else {
      setContextValues({
        ...contextValues,
        checkedFilters: contextValues.checkedFilters.filter(filterChecked => filterChecked.key !== filter.key)
      })
      localStorage.setItem('swissFarmersFilters', JSON.stringify(contextValues.checkedFilters.filter(filterChecked => filterChecked.key !== filter.key)))
      handleChangeDataFiltered({
        ...dataFiltered,
        [filter.key]: ''
      })
    }
  }

  function handleResetActions() {
    setContextValues({
      ...contextValues,
      filterInputValues: {
        search: '',
        agisId: ''
      }
    })
    handleChangeDataFiltered(defaultFilterValues)
  }

  return <>
    <El.PageHeaderActionButton
      size='large'
      disabled={JSON.stringify(dataFiltered) === JSON.stringify(defaultFilterValues)}
      onClick={() => handleResetActions()}
    >
      {t('Reset')}
    </El.PageHeaderActionButton>
    {filterValues.length > 0 && <StyledFiltersOptions
      text={t('Filters')}
      icon='filter'
      floating
      labeled
      button
      closeOnChange={false}
      pointing={'top right'}
      multiple
      className='icon'
      style={{ background: firstColor, color: 'white' }}
    >
      <Dropdown.Menu>
        <Dropdown.Menu scrolling>
          {filters.map(filter => {
            return <Dropdown.Item
              onClick={(e) => {
                e.stopPropagation()
                e.preventDefault()
              }}
              key={filter.key}
            >
              <Checkbox
                onClick={(e, data) => {
                  e.stopPropagation()
                  e.preventDefault()
                  handleCheckFilters(data.checked, filter)
                }}
                checked={Boolean(checkedFilters.find(filterChecked => filterChecked.key === filter.key))}
                label={filter.placeholder}
              />
            </Dropdown.Item>
          })}
        </Dropdown.Menu>
      </Dropdown.Menu>
    </StyledFiltersOptions>}
    {showExportFarmer && <StyledFiltersOptions
      text={t('Export')}
      icon='cloud download'
      floating
      labeled
      button
      closeOnChange={false}
      multiple
      className='icon'
      style={{ background: firstColor, color: 'white' }}
    >
      <Dropdown.Menu>
        <Dropdown.Menu onClick={(e) => {
          e.stopPropagation()
          e.preventDefault()
        }} scrolling>
          {farmersListOptions?.types?.map(type => {
            return type.key !== 'all_farmers' && <Dropdown.Item
              onClick={(e) => {
                e.stopPropagation()
                e.preventDefault()
              }}
              key={type.key}
            >
              <Checkbox
                onClick={(e, data) => {
                  e.stopPropagation()
                  e.preventDefault()
                  if (data.checked) {
                    setCheckedFarmerExportTypes([...checkedFarmerExportTypes, type])
                  } else {
                    setCheckedFarmerExportTypes(checkedFarmerExportTypes?.filter(typeChecked => typeChecked.key !== type.key))
                  }
                }}
                checked={checkedFarmerExportTypes?.find(typeChecked => typeChecked.key === type.key)}
                label={type.label}
              />
            </Dropdown.Item>
          })}
          <ExcelExport
            name={t('Export farmers')}
            buttonType={'button'}
            url={'farmers/export'}
            fileName={'farmers_export'}
            style={{ float: 'right', margin: 10, color: 'white' }}
            data={payloadFarmersExport}
          />
        </Dropdown.Menu>
      </Dropdown.Menu>
    </StyledFiltersOptions>
    }
    {showImportFarmers && <El.PageHeaderActionButton
      size='large'
      content={t('Import')}
      onClick={() => handleImportClick()}
    />
    }
    {!lightUserLogged && <El.PageHeaderActionButton
      size='large'
      onClick={() => navigate(RouteTypes.DAIRY_FACTORY_FARMERS_CREATE)}
    >
      {t('Create')}
    </El.PageHeaderActionButton>
    }
  </>
}
export default Actions
